module.exports = __webpack_public_path__ + "static/img/cont1402.df620d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1402.jpg
// module id = TP+Y
// module chunks = 0